import {
  configureStore,
  ThunkAction,
  Action,
  MiddlewareAPI,
  isRejectedWithValue,
  isPending,
  isFulfilled,
  isRejected,
  Middleware,
  AnyAction,
} from '@reduxjs/toolkit'
import { combineReducers } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { authApi } from 'services/auth'
import { categoryApi } from 'services/EventManagement'
import { eventApi } from 'services/EventManagement'
import { operationApi } from 'services/EventManagement'
import { settingsApi } from 'services/EventManagement'
import { servicePointApi } from 'services/OpsManagement'
import ui, { setAppLevelOverlayLoading, setLoading } from './slices/ui'
import auth from './slices/auth'
import environment from './slices/environment'
import { sendNotification } from 'components'
import { routeApi } from 'services/OpsManagement'
import { staticTourApi } from 'services/OpsManagement'
import { assetApi } from 'services/AssetManagement/asset'
import { consignmentApi } from 'services/MrfManagement/consignment'
import { regionApi } from 'services/OpsManagement'
import { opsGeneralApi } from 'services/OpsManagement'
import { opsSettingsApi } from 'services/OpsManagement'
import { inboundApi } from 'services/MrfManagement/inbound'
import { inventoryApi } from 'services/MrfManagement/inventory'
import { parcelApi } from 'services/MrfManagement/parcel'
import { processApi } from 'services/MrfManagement/process'
import { commonApi } from 'services/common'
import { fleetApi } from 'services/FleetManagement'
import { entityApi } from 'services/Engagement/entity'
import { contactApi } from 'services/Engagement/contact'
import { servicePointApi as engagementServicePointApi } from 'services/Engagement/servicePoint'
import { orderApi as engagementOrderApi } from 'services/Engagement/order'
import { insightApi } from 'services/InsightManagement'
import i18n from 'utils/i18n'
import { materialApi } from 'services/MrfManagement/material'
import { financialDetailApi } from 'services/Engagement/financialDetail'
import { activityApi } from 'services/AssetManagement/activity'
import { geomapApi } from 'services/OpsManagement'
import {
  mrfEnvironmentApi,
  engagementEnvironmentApi,
  employeeEnvironmentApi,
  alertEnvironmentApi,
} from './environment'
import { documentApi } from 'services/DocumentManagement'
import { reportsApi } from 'services/ReportManagement/reports'
import { caseApi } from 'services/Engagement/case'
import { externalApi as externalEngagementApi } from 'services/Engagement/external'
import { usersApi } from 'services/UserManagement/users'
import { taskPlansApi } from 'services/OpsManagement'
import { aiApi } from './ai/ai'
import { employeeApi } from 'services/EmployeeManagement'
import { mrfActivityApi } from './MrfManagement/activity'
import { widgetsApi } from './Widgets/widgets'
import { orderAssetSettingsApi } from './Engagement/orderAssetSettings'
import { alertApi } from './AlertManagement'
import { branchApi } from './MrfManagement/branch'
import { mrfCommonApi } from './MrfManagement/common'
import { opsDocumentApi } from './OpsManagement/document'
import { normalizationApi } from './MrfManagement/normalization'
import { integrationsApi } from './IntegrationManagement/integrationManagement'
import { passApi } from './Engagement/pass'
import { wasteAdministrationApi } from './Settings'
import { rfidChipsApi } from './AssetManagement/rfidChips'

//combine rtk-query and redux/toolkit reducers
const rootReducer = combineReducers({
  auth,
  ui,
  environment,
  [authApi.reducerPath]: authApi.reducer,
  [categoryApi.reducerPath]: categoryApi.reducer,
  [eventApi.reducerPath]: eventApi.reducer,
  [operationApi.reducerPath]: operationApi.reducer,
  [servicePointApi.reducerPath]: servicePointApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [routeApi.reducerPath]: routeApi.reducer,
  [assetApi.reducerPath]: assetApi.reducer,
  [consignmentApi.reducerPath]: consignmentApi.reducer,
  [parcelApi.reducerPath]: parcelApi.reducer,
  [processApi.reducerPath]: processApi.reducer,
  [inboundApi.reducerPath]: inboundApi.reducer,
  [inventoryApi.reducerPath]: inventoryApi.reducer,
  [commonApi.reducerPath]: commonApi.reducer,
  [fleetApi.reducerPath]: fleetApi.reducer,
  [entityApi.reducerPath]: entityApi.reducer,
  [contactApi.reducerPath]: contactApi.reducer,
  [engagementServicePointApi.reducerPath]: engagementServicePointApi.reducer,
  [engagementOrderApi.reducerPath]: engagementOrderApi.reducer,
  [insightApi.reducerPath]: insightApi.reducer,
  [financialDetailApi.reducerPath]: financialDetailApi.reducer,
  [materialApi.reducerPath]: materialApi.reducer,
  [activityApi.reducerPath]: activityApi.reducer,
  [staticTourApi.reducerPath]: staticTourApi.reducer,
  [regionApi.reducerPath]: regionApi.reducer,
  [opsGeneralApi.reducerPath]: opsGeneralApi.reducer,
  [opsSettingsApi.reducerPath]: opsSettingsApi.reducer,
  [geomapApi.reducerPath]: geomapApi.reducer,
  [mrfEnvironmentApi.reducerPath]: mrfEnvironmentApi.reducer,
  [engagementEnvironmentApi.reducerPath]: engagementEnvironmentApi.reducer,
  [documentApi.reducerPath]: documentApi.reducer,
  [caseApi.reducerPath]: caseApi.reducer,
  [externalEngagementApi.reducerPath]: externalEngagementApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [taskPlansApi.reducerPath]: taskPlansApi.reducer,
  [aiApi.reducerPath]: aiApi.reducer,
  [employeeApi.reducerPath]: employeeApi.reducer,
  [employeeEnvironmentApi.reducerPath]: employeeEnvironmentApi.reducer,
  [mrfActivityApi.reducerPath]: mrfActivityApi.reducer,
  [widgetsApi.reducerPath]: widgetsApi.reducer,
  [orderAssetSettingsApi.reducerPath]: orderAssetSettingsApi.reducer,
  [alertApi.reducerPath]: alertApi.reducer,
  [alertEnvironmentApi.reducerPath]: alertEnvironmentApi.reducer,
  [branchApi.reducerPath]: branchApi.reducer,
  [mrfCommonApi.reducerPath]: mrfCommonApi.reducer,
  [opsDocumentApi.reducerPath]: opsDocumentApi.reducer,
  [normalizationApi.reducerPath]: normalizationApi.reducer,
  [integrationsApi.reducerPath]: integrationsApi.reducer,
  [passApi.reducerPath]: passApi.reducer,
  [wasteAdministrationApi.reducerPath]: wasteAdministrationApi.reducer,
  [rfidChipsApi.reducerPath]: rfidChipsApi.reducer,
})

export const rtkQueryErrorLogger = (_api: MiddlewareAPI) => (next: any) => (action: any) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these use matchers!
  if (action.error) {
    if (action.meta.arg.endpointName === 'getAuthWithUser') {
      return
    }

    if (action.error.message?.startsWith('Network'))
      sendNotification({
        type: 'error',
        toastContent: i18n.t('response.message.network.error') as string,
      })
    else if (action.error.message?.startsWith('Request timeout'))
      sendNotification({
        type: 'error',
        toastContent: i18n.t('response.message.timeout.error') as string,
      })
  }
  if (isRejectedWithValue(action)) {
    if (action.payload.errorOverride) {
      store.dispatch(setLoading(false))

      return next(action)
    } else if (action.payload.status === 403 || action.payload.status === 401) {
      sendNotification({
        type: 'error',
        toastContent: JSON.stringify(action.payload.data.detail.message),
        header: 'Error',
        toastOptions: {},
      })
      //return window.location.assign(`${window.envVariables.REACT_APP_BASE_URL}/login/`)
    } else if (action.payload.status >= 500) {
      store.dispatch(setLoading(false))
      sendNotification({
        type: 'error',
        toastContent: i18n.t('response.message.server.error') as string,
        header: 'Error',
        toastOptions: {},
      })
    } else {
      // Regular error scenario - print error message that backend sends
      sendNotification({
        type: 'error',
        toastContent: action.payload.message,
        header: 'Error',
      })
    }
  }

  return next(action)
}

const appOverlayEndpointsSet = new Set(['getAuthWithUser', 'getAuth', 'setLanguage'])

export const appLevelLoadingSetter = (_api: MiddlewareAPI) => (next: any) => (action: any) => {
  if (isFulfilled(action) || isRejected(action)) {
    store.dispatch(setLoading(false))

    if (appOverlayEndpointsSet.has(action.meta.arg.endpointName)) {
      store.dispatch(setAppLevelOverlayLoading(false))
    }
  } else if (isPending(action)) {
    store.dispatch(setLoading(true))

    if (appOverlayEndpointsSet.has(action.meta.arg.endpointName)) {
      store.dispatch(setAppLevelOverlayLoading(true))
    }
  }
  return next(action)
}

// -------------------- Cross-tab Invalidate Sync (loop-safe) --------------------
const apis = [commonApi, caseApi] as const

const reducerPaths = apis.map((a) => a.reducerPath)
const shouldSync = (type: string) =>
  reducerPaths.some((p) => type === `${p}/invalidateTags` || type === `${p}/resetApiState`)

const CROSS_TAB_FLAG = 'rtkqFromCrossTab'

type SerializableMeta = Record<string, unknown>

type TagDescription = string | { type: string; id?: unknown }

type CrossTabAction<TType extends string = string> = {
  type: TType
  payload?: TagDescription[]
  meta?: SerializableMeta
}

export type CrossTabPayload<TType extends string = string> = {
  id: string
  origin: string
  action: CrossTabAction<TType>
}

const makeId = () => {
  try {
    return crypto.randomUUID()
  } catch {
    return `${Date.now()}-${Math.random()}`
  }
}

const tabId =
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random()}`

const hasWindow = typeof window !== 'undefined'
const bc =
  hasWindow && 'BroadcastChannel' in window ? new BroadcastChannel('rtkq-cross-tab-sync') : null
const LOCALSTORAGE_KEY = '__rtkq_cross_tab_sync__'

const seenIds = new Set<string>()
const capSeen = () => {
  if (seenIds.size > 200) seenIds.clear()
}

const emitCrossTab = (payload: CrossTabPayload) => {
  try {
    if (bc) {
      bc.postMessage(payload)
    } else if (hasWindow && 'localStorage' in window) {
      localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify({ ...payload, ts: Date.now() }))
    }
  } catch {}
}

export const rtkqCrossTabSyncMiddleware: Middleware<{}, RootState> =
  (_api) => (next) => (action) => {
    const a = action as AnyAction & {
      payload?: TagDescription[] | unknown
      meta?: SerializableMeta & { [key: string]: unknown }
      type: string
    }

    const result = next(a)

    if (
      typeof a.type === 'string' &&
      shouldSync(a.type) &&
      !(a.meta && (a.meta as Record<string, unknown>)[CROSS_TAB_FLAG] === true)
    ) {
      const payload: CrossTabPayload<string> = {
        id: makeId(),
        origin: tabId,
        action: {
          type: a.type,
          payload: Array.isArray(a.payload) ? (a.payload as TagDescription[]) : undefined,
          meta: (a.meta ?? {}) as SerializableMeta,
        },
      }
      emitCrossTab(payload)
    }

    return result
  }

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(rtkQueryErrorLogger)
      .concat(appLevelLoadingSetter)
      .concat(rtkqCrossTabSyncMiddleware) // cross-tab sync (loop-safe)
      .concat(authApi.middleware)
      .concat(categoryApi.middleware)
      .concat(eventApi.middleware)
      .concat(operationApi.middleware)
      .concat(settingsApi.middleware)
      .concat(servicePointApi.middleware)
      .concat(routeApi.middleware)
      .concat(staticTourApi.middleware)
      .concat(assetApi.middleware)
      .concat(consignmentApi.middleware)
      .concat(regionApi.middleware)
      .concat(geomapApi.middleware)
      .concat(parcelApi.middleware)
      .concat(commonApi.middleware)
      .concat(inboundApi.middleware)
      .concat(inventoryApi.middleware)
      .concat(processApi.middleware)
      .concat(fleetApi.middleware)
      .concat(entityApi.middleware)
      .concat(contactApi.middleware)
      .concat(engagementServicePointApi.middleware)
      .concat(engagementOrderApi.middleware)
      .concat(insightApi.middleware)
      .concat(materialApi.middleware)
      .concat(financialDetailApi.middleware)
      .concat(activityApi.middleware)
      .concat(mrfEnvironmentApi.middleware)
      .concat(engagementEnvironmentApi.middleware)
      .concat(documentApi.middleware)
      .concat(caseApi.middleware)
      .concat(externalEngagementApi.middleware)
      .concat(reportsApi.middleware)
      .concat(opsGeneralApi.middleware)
      .concat(opsSettingsApi.middleware)
      .concat(usersApi.middleware)
      .concat(taskPlansApi.middleware)
      .concat(employeeApi.middleware)
      .concat(employeeEnvironmentApi.middleware)
      .concat(aiApi.middleware)
      .concat(mrfActivityApi.middleware)
      .concat(widgetsApi.middleware)
      .concat(orderAssetSettingsApi.middleware)
      .concat(alertEnvironmentApi.middleware)
      .concat(alertApi.middleware)
      .concat(branchApi.middleware)
      .concat(mrfCommonApi.middleware)
      .concat(opsDocumentApi.middleware)
      .concat(normalizationApi.middleware)
      .concat(integrationsApi.middleware)
      .concat(passApi.middleware)
      .concat(wasteAdministrationApi.middleware)
      .concat(rfidChipsApi.middleware),
})

const handleIncoming = (raw: unknown): void => {
  const data = raw as CrossTabPayload<string>
  if (!data || data.origin === tabId) return

  const act = data.action
  if (!act?.type || !shouldSync(act.type)) return

  if (data.id) {
    if (seenIds.has(data.id)) return
    seenIds.add(data.id)
    capSeen()
  }

  const incoming: CrossTabAction<string> = {
    ...act,
    meta: { ...((act.meta as SerializableMeta) ?? {}), [CROSS_TAB_FLAG]: true },
  }

  store.dispatch(incoming as unknown as AnyAction)
}

if (bc) {
  bc.onmessage = (evt) => handleIncoming(evt.data)
} else if (hasWindow) {
  window.addEventListener('storage', (e) => {
    if (e.key !== LOCALSTORAGE_KEY || !e.newValue) return
    try {
      handleIncoming(JSON.parse(e.newValue))
    } catch {}
  })
}

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof rootReducer>
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>
export type AppDispatch = typeof store.dispatch

export default store
